module.exports = __webpack_public_path__ + "img/deled.f65f75d0.svg";